import initialState from './initialState';

export function purchaseRebateItemsHasErrored(
  state = initialState.purchaseRebateItemsHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEMS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateItemsIsLoading(
  state = initialState.purchaseRebateItemsIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateItems(
  state = initialState.purchaseRebateItems,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEMS_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function purchaseRebateItemHasErrored(
  state = initialState.purchaseRebateItemHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEM_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateItemIsLoading(
  state = initialState.purchaseRebateItemIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateItem(
  state = initialState.purchaseRebateItem,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_ITEM_FETCH_DATA_SUCCESS':
      return action.item;
    default:
      return state;
  }
}

export function purchaseRebateProductItemsHasErrored(
  state = initialState.purchaseRebateProductItemsHasErrored,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_PRODUCT_ITEMS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function purchaseRebateProductItemsIsLoading(
  state = initialState.purchaseRebateProductItemsIsLoading,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_PRODUCT_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function purchaseRebateProductItems(
  state = initialState.purchaseRebateProductItems,
  action,
) {
  switch (action.type) {
    case 'PURCHASE_REBATE_PRODUCT_ITEMS_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}
